interface ProvidedI18nMessages {
    [key: string]: string;
}

export default function (): ProvidedI18nMessages {
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    (window as any).__JSD_I18N_MESSAGES = (window as any).__JSD_I18N_MESSAGES || {};

    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    return (window as any).__JSD_I18N_MESSAGES;
}
